// Formatting helpers for display.

export function fmtMg(n: number, fractionDigits = 1): string {
  if (!Number.isFinite(n)) return '—';
  return `${n.toFixed(fractionDigits).replace(/\.0$/, '')} mg`;
}

export function fmtTime(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  } catch {
    return '';
  }
}

export function fmtDate(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
  } catch {
    return iso;
  }
}

export function todayYmd(): string {
  const now = new Date();
  return [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
  ].join('-');
}

// Browser-detected IANA timezone, e.g. "America/Los_Angeles". Pairs with
// the server's user-tz-aware day boundary logic on /api/doses so a dose
// logged at 11 pm local drops out of "Today's doses" once local
// midnight passes — not seven hours later at UTC midnight.
export function browserTz(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

export function ymdAddDays(ymd: string, n: number): string {
  const dt = new Date(`${ymd}T00:00:00`);
  dt.setDate(dt.getDate() + n);
  return [
    dt.getFullYear(),
    String(dt.getMonth() + 1).padStart(2, '0'),
    String(dt.getDate()).padStart(2, '0'),
  ].join('-');
}

// Convert a UTC ISO timestamp ("2026-05-14T03:15:00Z") to the user's
// local YYYY-MM-DD. Pairs with todayYmd() — both use local-time
// year/month/date so callers can bucket events by the user's calendar
// rather than by UTC. A dose stored at 2026-05-14T03:15Z is "5/13" for
// a PST user and "5/14" for a UTC user; this returns the user's view.
export function localYmd(iso: string): string {
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return iso.slice(0, 10);
  return [
    dt.getFullYear(),
    String(dt.getMonth() + 1).padStart(2, '0'),
    String(dt.getDate()).padStart(2, '0'),
  ].join('-');
}
